import React from 'react'
import { ComingSoon } from '../../../Components'

export default function Jobs() {
    return (
        <div>
            <ComingSoon />
        </div>
    )
}
